import { extractAxiosErrorMessage } from '@/helpers/apiUtilities.js';

export function getState (alertGroups = 'default') {
  if (Array.isArray(alertGroups)) {
    const alerts = {};
    for (const alertGroup of alertGroups) {
      alerts[alertGroup] = [];
    }
    return {
      alerts
    };
  }

  return {
    alerts: {
      [alertGroups]: []
    }
  };
}

export const mutations = {
  addAlert: function (state, payload) {
    let message = payload.message;
    if (payload.error) {
      message += ' ' + extractAxiosErrorMessage(payload.error);
    }

    const alert = {
      status: payload.status,
      message,
      dismissible: true
    };

    if (payload.alertGroup) {
      state.alerts[payload.alertGroup].push(alert);
    } else {
      state.alerts.default.push(alert);
    }
  },
  clearAlerts: function (state, alertGroup) {
    if (alertGroup) {
      state.alerts[alertGroup] = [];
    } else {
      state.alerts.default = [];
    }
  }
};

export default {
  namespaced: true,
  getState,
  mutations
};
